import SetPasswordForm from "../../common/SetPasswordForm";


const StudentSetPassword = () => {
    return <SetPasswordForm type="schoolstudent" />;
};

export default StudentSetPassword;